import { useState } from "react";
import { useSelector } from "react-redux";
// import ActivePromocodeList from "./ActivePromocodeList";
// import CreatePromocodeFormTab from "./CreatePromocodeFormTab";
import PromocodeList from "./PromocodeList";

const Promocodes = ({ addPromocodeModel, closeAddModel }) => {
  const [title, setTitle] = useState("Promocodes");
  const { userDetails } = useSelector((state) => state.user);

  return (
    <>
      {/* <CreatePromocodeFormTab
        userDetails={userDetails}
        title={title}
        ClickHandler={(title) => {
          setTitle(title);
        }}
      />
      {title === "Promocodes" ? (
        <ActivePromocodeList
          addPromocodeModel={addPromocodeModel}
          closeAddModel={closeAddModel}
        />
      ) : title === "My Promocodes" && userDetails.userType === "organizer" ? (
        <PromocodeList
          addPromocodeModel={addPromocodeModel}
          closeAddModel={closeAddModel}
        />
      ) : (
        ""
      )} */}
      <PromocodeList
        addPromocodeModel={addPromocodeModel}
        closeAddModel={closeAddModel}
      />
    </>
  );
};

export default Promocodes;
